import initialState from '../store/initial-state'
import {
  NOTIFICATION_GET_DATA,
  NOTIFICATION_GET_DATA_SUCCESS,
  NOTIFICATION_GET_DATA_FAILURE,
  NOTIFICATION_SET_PID,
  NOTIFICATION_SHOW_MODAL,
  NOTIFICATION_EMPTY,
  NOTIFICATION_SET_REQUEST_PERMISSION_ID,
  NOTIFICATION_UNSET_REQUEST_PERMISSION_ID,
  ENABLE_SOCKET
} from '../constants/notification-types'

export default (state = initialState.notifications, action) => {
  switch (action.type) {
    case NOTIFICATION_SET_PID:
      return {
        ...state,
        pid: action.payload
      }

    case NOTIFICATION_GET_DATA:
      return {
        ...state,
        isFetching: true
      }

    case NOTIFICATION_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        // jobs: action.payload.jobs,
        toBeConfirmed: action.payload.toBeConfirmed,
        userRequests: action.payload.userRequests,
        showNotification: action.payload.showNotification,
        showModal: action.payload.showModal
      }

    case NOTIFICATION_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        jobs: [],
        toBeConfirmed: 0,
        userRequests: [],
        showNotification: false,
        showModal: false,
      }

    case NOTIFICATION_SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload,
        showNotification: !action.payload
      }

    case NOTIFICATION_EMPTY:
      return {
        ...state,
        pid: null,
        isFetching: false,
        toBeConfirmed: 0,
        userRequests: [],
        showNotification: false,
        showModal: false
      }

    case NOTIFICATION_SET_REQUEST_PERMISSION_ID:
      return {
        ...state,
        requestIdToSend: action.payload,
      }

    case NOTIFICATION_UNSET_REQUEST_PERMISSION_ID:
      return {
        ...state,
        requestIdToSend: '',
      }

    case ENABLE_SOCKET:
      return {
        ...state,
        socketStatus: action.payload.socketStatus,
      }

    default: return { ...state }
  }
}